import React from 'react';
import { Tag } from 'antd';
import Language from 'components/Language';

const LanguageTag = ({ className, language, languageName, locale }) => ((language || locale) ? (
  <Tag className={className}>
    <Language locale={locale || language} languageName={languageName} />
  </Tag>
) : null);

export default LanguageTag;
